/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import HrRecording from '../../components/hr-recording';
import moment from 'moment';
import { t } from '../../multi-language/multi-lang.service';
function HRChart(_a) {
    var recordHr = _a.recordHr, record = _a.record;
    return (React.createElement("div", { className: 'wrap-hr-section page-break' },
        React.createElement("div", { className: "header-card pl-3 fs-4 cardio-in" }, t('charts.recording.summary')),
        React.createElement("div", { className: 'hr-section' },
            React.createElement("div", { className: 'recording-section' },
                React.createElement("div", { className: 'info-bottom-recording cardio-in' },
                    React.createElement("p", { className: '' },
                        t('general_words.time'),
                        ":  ",
                        moment(record.start).format('MMM DD, YYYY, HH:mm'),
                        " - ",
                        moment(record.end).format('HH:mm')),
                    React.createElement("p", { className: '' },
                        t('charts.recording.time'),
                        ": ",
                        Math.floor(record.total / 60),
                        " ",
                        t('general_words.minutes'),
                        " ",
                        record.total % 60,
                        " ",
                        t('general_words.seconds'))),
                recordHr && React.createElement(HrRecording, { recordHr: recordHr }) /*cardio section*/))));
}
export default HRChart;
//# sourceMappingURL=hr-chart.js.map